import { defineStore } from 'pinia';
import { computed } from 'vue';
import { defineWorkspaceEntityHydration } from '#layers/runtime/public';

/**
 * The extension catalog of a workspace runtime.
 *
 * Read without an entitlement check: the protected `studio_access` policy grants `extension:read` in
 * every workspace, and a candidate cannot evaluate entitlements anyway because the permissions store
 * follows the active runtime.
 */
export const workspaceExtensionsHydration = defineWorkspaceEntityHydration(
	(store) => store.WorkspaceExtension.query((q) => q.many()),
	{ empty: [] },
);

/**
 * The connectors those extensions contribute, as data source providers. Gated on `extension:read`
 * like the extension catalog, because every member sees which connector backs a data source.
 */
export const workspaceDataConnectorsHydration = defineWorkspaceEntityHydration(
	(store) => store.WorkspaceDataConnector.query((q) => q.many()),
	{ empty: [] },
);

export const useExtensionsStore = defineStore('extensions', () => {
	const { data: extensionCatalog } = workspaceExtensionsHydration.use();
	const { data: connectorCatalog } = workspaceDataConnectorsHydration.use();

	const dataConnectors = computed(() => connectorCatalog.value.filter((connector) => connector.extensionId));

	return {
		extensions: extensionCatalog,
		dataConnectors,
	};
});
